import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../api/auth";
import "../index.css";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await loginUser(formData);
      console.log("✅ Login API Response:", res.data);

      // ✅ check for 'success' instead of 'status'
      if (res.data && res.data.success) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        setMessage(res.data.message || "Login successful!");

        // redirect to profile after success
        setTimeout(() => navigate("/profile"), 1000);
      } else {
        setMessage(res.data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("❌ Login Error:", err);

      if (err.response && err.response.data) {
        const errorData = err.response.data;
        if (errorData.message) {
          setMessage(errorData.message);
        } else if (errorData.errors) {
          const errorMessages = Object.values(errorData.errors).flat().join(" ");
          setMessage(errorMessages);
        } else {
          setMessage("Invalid credentials or server error.");
        }
      } else {
        setMessage("Network error. Please try again.");
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit">Login</button>
        </form>

        {message && (
          <p
            className={
              message.toLowerCase().includes("success") ? "success" : "error"
            }
          >
            {message}
          </p>
        )}

        <p>
          Don’t have an account?{" "}
          <span
            onClick={() => navigate("/register")}
            style={{ color: "#007bff", cursor: "pointer" }}
          >
            Register
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
